const state = {
    lang: 'en'
}

const mutations = {
    set_language(state, payload) {
        state.lang = payload
    }
}

const actions = {
    setLanguage({ commit }, payload) {
        commit('set_language', payload)
    }
}

const getters = {
    lang: state => state.lang
}

export default { state, actions, mutations, getters }
